import apiClient from '../axios.js'

/**
 * 人工請款客戶管理 API
 */
export const manualPaymentService = {
    /**
     * 取得即將到期的人工請款客戶列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁筆數
     * @param {string} params.search - 搜尋關鍵字
     * @param {number} params.daysBefore - 到期前幾天（預設 30）
     * @returns {Promise<Object>} 客戶列表
     */
    getDueSoonClients: async (params = {}) => {
        const response = await apiClient.get('/system/manual-payments/due-soon', {
            params
        })
        return response
    },

    /**
     * 取得寬限期內的人工請款客戶列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁筆數
     * @param {string} params.search - 搜尋關鍵字
     * @returns {Promise<Object>} 客戶列表
     */
    getGracePeriodClients: async (params = {}) => {
        const response = await apiClient.get('/system/manual-payments/grace-period', {
            params
        })
        return response
    },

    /**
     * 取得超過寬限期的人工請款客戶列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁筆數
     * @param {string} params.search - 搜尋關鍵字
     * @returns {Promise<Object>} 客戶列表
     */
    getOverdueClients: async (params = {}) => {
        const response = await apiClient.get('/system/manual-payments/overdue', {
            params
        })
        return response
    }
}
